export default {
    isDebugMode: false,
    ws_path: "https://api.monentretienpro.fr/public/index.php",
    upload_path: "https://api.monentretienpro.fr/uploads",
    router_basename: ''
}


// WEBPACK FOOTER //
// ./src/config.js